<script setup lang="ts">
import { useFareOptimizerStore } from '@/store/fareOptimizer'

const store = useFareOptimizerStore()

const columns = [
  { title: 'Mês/ano', key: 'month' },
  { title: 'Cons. Ponta (kWh)', key: 'peak_invoiced_consumption' },
  { title: 'Cons. F. Ponta (kWh)', key: 'off_peak_invoiced_consumption' },
  { title: 'Dem. Ponta (kW)', key: 'peak_measured_demand' },
  { title: 'Dem. F. Ponta (kW)', key: 'off_peak_measured_demand' },
  { title: 'Reat. Ponta (kVArh)', key: 'peak_reactive_energy' },
  { title: 'Reat. F. Ponta (kVArh)', key: 'off_peak_reactive_energy' },
]

const formatNumber = (value: number) => {
  if (value === undefined || value === null) return '-'
  return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
</script>

<template>
  <div class="mt-8 h-max w-full bg-white shadow-4">
    <div class="border-b-2 border-stroke">
      <h1 class="border-stroke p-4 font-satoshi text-base font-bold text-black">
        Histórico dos últimos {{ store.historicalData.length }} meses
      </h1>
    </div>

    <div v-if="store.historicalData.length === 0" class="p-4 text-center font-satoshi text-base font-medium text-body">
      Nenhum dado histórico disponível.
    </div>

    <div v-else class="overflow-x-auto">
      <table class="w-full text-left text-sm">
        <thead class="bg-slate-50 font-satoshi text-base font-medium text-black">
          <tr>
            <th v-for="col in columns" :key="col.key" scope="col" class="whitespace-nowrap px-4 py-3">
              {{ col.title }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in store.historicalData"
            :key="index"
            class="border-b-2 border-stroke"
          >
            <td class="whitespace-nowrap p-4 font-satoshi text-base font-medium text-black">{{ item.month }}</td>
            <td class="whitespace-nowrap p-4 font-satoshi text-base font-medium text-body">{{ formatNumber(item.peak_invoiced_consumption) }}</td>
            <td class="whitespace-nowrap p-4 font-satoshi text-base font-medium text-body">{{ formatNumber(item.off_peak_invoiced_consumption) }}</td>
            <td class="whitespace-nowrap p-4 font-satoshi text-base font-medium text-body">{{ formatNumber(item.peak_measured_demand) }}</td>
            <td class="whitespace-nowrap p-4 font-satoshi text-base font-medium text-body">{{ formatNumber(item.off_peak_measured_demand) }}</td>
            <td class="whitespace-nowrap p-4 font-satoshi text-base font-medium text-body">{{ formatNumber(item.peak_reactive_energy) }}</td>
            <td class="whitespace-nowrap p-4 font-satoshi text-base font-medium text-body">{{ formatNumber(item.off_peak_reactive_energy) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
